import React, { useState } from 'react';
import { Modal, Input, Row, Form } from 'antd';
import { renameFlow } from '../../../lib/api/flow-api';
import { Flow } from '../../../types/flow';
import { ModalTitle } from '../../../components/text/Titles';

type Props = { visible: boolean; onClose: () => any; onCancel: () => any; flow: Flow };

export const RenameFlow = (props: Props) => {
  const { visible, onClose, onCancel, flow } = props;

  const [name, setName] = useState<null | string>(flow.name);

  const onRename = async () => {
    if (!name) return;

    const request = await renameFlow(name, flow.id);
    console.log(request);
    onClose();
  };

  return (
    <Modal
      maskClosable={false}
      width={768}
      visible={visible}
      title={<ModalTitle>Rename Flow: {flow.name}</ModalTitle>}
      onOk={onRename}
      onCancel={onCancel}>
      <>
        <Row style={{ marginTop: '16px' }}>
          <Form layout={'vertical'}>
            <Form.Item label="Name">
              <Input value={name || undefined} onChange={event => setName(event.target.value)} />
            </Form.Item>
          </Form>
        </Row>
      </>
    </Modal>
  );
};

export default RenameFlow;
